import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const ComingSoon = ({
  tournamentName = 'Tournament',
  title = 'To Be Announced',
  message = 'Stay tuned for updates on our participation in this tournament.',
  footerMessage = 'More details to follow when tournament information is available! 🏆',
}) => {
  return (
    <Box
      sx={{
        bgcolor: '#000000',
        color: '#FFFFFF',
        py: { xs: 8, md: 12 },
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container maxWidth="lg">
        <MotionBox
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          sx={{ textAlign: 'center' }}
        >
          <Typography
            variant="h2"
            sx={{
              color: '#FFD700',
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '3rem' },
              fontFamily: 'Merriweather, serif',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              mb: 4,
            }}
          >
            {tournamentName}
          </Typography>
          <Box
            sx={{
              backgroundColor: 'rgba(255, 215, 0, 0.1)',
              borderRadius: 3,
              p: { xs: 4, md: 6 },
              border: '2px solid #FFD700',
              maxWidth: '600px',
              mx: 'auto',
            }}
          >
            <Typography
              sx={{
                color: '#FFD700',
                fontSize: { xs: '1.5rem', md: '2rem' },
                fontWeight: 'bold',
                mb: 3,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                fontFamily: 'Merriweather, serif',
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                color: '#FFFFFF',
                fontSize: { xs: '1rem', md: '1.2rem' },
                fontFamily: 'Roboto, sans-serif',
                lineHeight: 1.5,
                mb: 2,
              }}
            >
              {message}
            </Typography>
            <Typography
              sx={{
                color: '#CCCCCC',
                fontSize: { xs: '0.9rem', md: '1rem' },
                fontFamily: 'Roboto, sans-serif',
                fontStyle: 'italic',
              }}
            >
              {footerMessage}
            </Typography>
          </Box>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default ComingSoon;
